//@ts-nocheck

import React from 'react'
import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import businessMockups from './../assets/HomePage/multi-device.png'
import phoneMockups from './../assets/HomePage/phone_mockup.png'

const Button = ({ children, className, ...props }) => (
  <button
    className={`
      bg-[#1f1f1f] hover:bg-blue-600
      text-white font-medium
      px-4 sm:px-6 md:px-8 py-3 md:py-4 text-base md:text-lg rounded-xl
      inline-flex items-center justify-center
      transform transition-all duration-200
      hover:scale-105 hover:shadow-lg hover:shadow-blue-800/25
      ${className}
    `}
    {...props}
  >
    {children}
  </button>
)

export default function ComparisonSection() {
  return (
    <div className="flex flex-col items-center max-w-7xl mx-auto p-4 sm:p-6">
      <div className="flex flex-col lg:flex-row w-full relative mb-8 lg:mb-12">
        {/* Build for me card */}
        <div className="relative flex-1 rounded-3xl bg-[#faf9f8] p-6 sm:p-8 pb-10 sm:pb-12 lg:mr-3 mb-6 lg:mb-0">
          <div className="relative h-60 sm:h-72 md:h-80 mb-6 sm:mb-8">
            <img
              src={phoneMockups}
              alt="Mobile analytics interface"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold mb-3 sm:mb-4 text-gray-900">Personal Credit</h2>
          <p className="text-gray-600 text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed">
            Monitor and understand your financial health with ease. Your FICO score—
            based on payment history, credit use, and account age—impacts access to 
            credit cards, loans, and mortgages. Tools like Credit Karma and CreditWise 
            offer real-time updates to help you stay informed.
          </p>
        </div>

        {/* OR divider */}
        <div className="absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 z-30 hidden lg:block">
          <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gradient-to-r from-gray-800 to-black shadow-lg flex items-center justify-center p-2 border-2 border-white">
            <img src="/vs.svg" alt="VS" className="w-full h-full object-contain" />
          </div>
        </div>

        {/* Mobile VS divider - only shown on smaller screens */}
        <div className="relative w-full flex justify-center items-center my-4 lg:hidden">
          <div className="w-14 h-14 rounded-full bg-gradient-to-r from-gray-800 to-black shadow-lg flex items-center justify-center p-2 border-2 border-white">
            <img src="/vs.svg" alt="VS" className="w-full h-full object-contain" />
          </div>
        </div>

        {/* Do it yourself card */}
        <div className="relative flex-1 rounded-3xl bg-[#1a1a1a] p-6 sm:p-8 pb-10 sm:pb-12 lg:ml-3">
          <div className="relative h-60 sm:h-72 md:h-80 mb-6 sm:mb-8">
            <img
              src={businessMockups}
              alt="Person working on laptop"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold mb-3 sm:mb-4 text-white">Business Credit</h2>
          <p className="text-gray-300 text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed">
            Your business's financial reputation drives growth. Business credit scores 
            (e.g., Experian Intelliscore, Equifax OneScore) reflect payment history, 
            debts, and public records. With FuteurAI, the "Credit Karma for business," 
            track scores, monitor changes, and boost creditworthiness in real time.
          </p>
        </div>
      </div>

      {/* Added button after the comparison section */}
      <div className="text-center transform transition-all duration-500 hover:translate-y-[-4px] w-full sm:w-auto">
        <Link to="/credit-comparsion" className="block w-full sm:inline-block">
          <Button className="w-full sm:w-auto">
            Learn More About the Differences <ChevronRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
      </div>
    </div>
  )
}
